<template>
  <div class="location">
    <nova-select
      :items="courses"
      class="m-b-2"
      v-model="val"
      @change="change"
    ></nova-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Search",
  data() {},
  props: ["value"],
  methods: {
    change(e) {},
  },
  computed: {
    ...mapState(["courses"]),
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>